// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"5b61d2b0","182":"320605b2","239":"e39fb35b","455":"cfabb115","484":"14cb0921","977":"240addac"}[chunkId] + ".chunk.js";
};